import { render } from "./RenewDetail.vue?vue&type=template&id=16960750&scoped=true"
import script from "./RenewDetail.vue?vue&type=script&lang=js"
export * from "./RenewDetail.vue?vue&type=script&lang=js"

import "./RenewDetail.vue?vue&type=style&index=0&id=16960750&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16960750"]])

export default __exports__